<template>
  <div id="wizardCard" class="card card-wizard">
    <div class="vue-form-wizard md">
      <div class="content">
        <div class="container">
          <div class="row">
            <legend>Listado de Correcciones </legend>
            <!-- <div class="col-sm-6 col-md-6 col-lg-6">
              <b-button @click.prevent="getcorrecciones()" v-b-popover.hover.top="'Refrescar'" class="btn-s edit mr-2" variant="primary">
                <i class="fas fa-undo-alt"></i>
              </b-button>
            </div> -->
          </div>
          <div>
            <div class="row">

              <div class="col-6 pull-right">
                <label>Buscar:</label>
                <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
              </div>
              <div class="col-6  d-flex align-items-end justify-content-end">
                <export-excel class="btn btn-wd btn-success pull-right" :data="lista_correcciones2" :meta="meta" :fields="lista_campos" worksheet="Correcciones" name="Correcciones_declaraciones.xls" v-if="lista_correcciones2.length > 0">
                  <span class="btn-label">
                    <i class="fa fa-file-excel"></i>
                  </span>
                  Descargar
                </export-excel>
              </div>
            </div>
            <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <!-- item-key="id" -->
                <v-app>
                  <v-data-table :headers="headers" :search="filter" :custom-filter="customFilter" :items="lista_correcciones" single-select item-key="id" show-expand :expanded.sync="expanded" @click:row="rowClick">
                    <!-- <v-data-table :headers="headers" :items="lista_correcciones"  :single-expand="true" :expanded.sync="expanded" :show-expand="true" class=""> -->
                    <template v-slot:item.acciones="{ item }">
                      <div class="d-flex justify-content-center">
                        <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success" :disabled="edit_item != null">
                          <i class="fas fa-pencil-alt"></i></b-button>
                      </div>
                    </template>
                    <template v-slot:item.rfc="{ item }">
                      <div>{{item.servidor.rfc}} </div>
                    </template>
                    <template v-slot:item.nombres="{ item }">
                      <div>{{item.servidor.nombres + ' '+ item.servidor.primer_apellido +' '+item.servidor.segundo_apellido}} </div>
                    </template>
                    <template v-slot:item.area="{ item }">
                      <div>{{item.encargo.area_adscripcion}}</div>
                    </template>
                    <template v-slot:item.created_at="{ item }">
                      <div>{{item.created_at | dateFormat }}</div>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">

                        <v-card :key="item.id" class="p-1 m-0" flat>
                          <v-card-text class="p-1">
                            <h3 class="text-h5 mb-2 mt-2">
                              {{item.servidor.nombres + ' '+ item.servidor.primer_apellido +' '+item.servidor.segundo_apellido}}
                            </h3>
                            <div class="blue--text mb-2">
                              {{item.servidor.rfc}}
                            </div>
                          </v-card-text>
                          <v-divider class="m-0 p-0 mb-2"></v-divider>
                          <v-row class="text-left m-0 pt-2 pb-2">
                            <v-col cols="6" class="m-0 p-1 pb-3 border-bottom" v-if="item.origen">
                              <legend class="h4 pl-0 mb-3 mt-0"> Corrección Origen:</legend>
                              <div class="m-0 p-0 pb-2  text-wrap" v-for="(value, key) in item.origen" :key="key">
                                <div v-if="key === 'datos_encargo_actual'">
                                  <strong>{{ key.replace("_", " ") }}:</strong>
                                  <div class=" text-wrap" v-for="(value_2, key_2) in flatData(value, 'ente')" :key="key_2+'2'">
                                    <b>{{ key_2 }}</b> : {{value_2}}
                                  </div>
                                </div>
                              </div>
                            </v-col>
                            <v-col cols="6" class="m-0 p-1 pb-3 border-bottom border-left" v-if="item.cambio">
                              <legend class="h4 pl-3 mb-3 mt-0"> Corrección Cambio:</legend>
                              <div cols="6" class="m-0 p-0 pl-3 text-wrap" v-for="(value, key) in item.cambio" :key="key">
                                <div v-if="key === 'datos_encargo_actual'">
                                  <strong>{{ key.replace("_", " ") }}:</strong>
                                  <div class=" text-wrap" v-for="(value_2, key_2) in flatData(value, 'ente')" :key="key_2+'2'">
                                    <b>{{ key_2 }}</b> : {{value_2}}
                                  </div>
                                </div>

                              </div>
                            </v-col>
                          </v-row>
                          <v-row class="text-left m-0 pt-2 pb-2">
                            <v-col cols="6" class="m-0 p-1 pb-3 border-bottom" v-if="item.origen">
                              <legend class="h4 pl-0 mb-3 mt-0"> Corrección Declaración Origen:</legend>
                              <div cols="6" class="m-0 p-0 text-wrap" v-for="(value, key) in item.orgen_declaracion" :key="key">
                                <div v-if="key === 'Tipo_Dec'">
                                  <strong>{{ key.replace("_", " ") }}:</strong> {{value}}
                                </div>
                                <div v-if="key === 'periodo'">
                                  <strong>{{ key.replace("_", " ") }}:</strong> {{value}}
                                </div>
                              </div>
                            </v-col>
                            <v-col cols="6" class="m-0 p-1 pb-3 border-bottom border-left" v-if="item.cambio">
                              <legend class="h4 pl-3 mb-3 mt-0"> Corrección Declaración Cambio:</legend>
                              <div cols="6" class="m-0 p-0 pl-3 text-wrap" v-for="(value, key) in item.cambio_declaracion" :key="key">
                                <div v-if="key === 'Tipo_Dec'">
                                  <strong>{{ key.replace("_", " ") }}:</strong> {{value}}
                                </div>
                                <div v-if="key === 'periodo'">
                                  <strong>{{ key.replace("_", " ") }}:</strong> {{value}}
                                </div>
                              </div>
                            </v-col>
                          </v-row>

                          <v-row class="text-left m-0 pt-2 pb-2">
                            <v-col class=" m-0 p-1" tag="strong" cols="12"> Observaciones: </v-col>
                            <v-col cols="12" class="m-0 p-1 pb-3 border-bottom">{{item.observaciones? item.observaciones :'Sin observaciones.'}}</v-col>
                          </v-row>
                          <v-row class="text-left m-0 pt-2 pb-2" v-if="item.usuario">
                            <v-col class=" m-0 p-1 " tag="strong" cols="12"> Datos del creador del movimiento: </v-col>
                            <v-col cols="12" class="m-0 p-1 ">{{item.usuario.Nombre + ' '+ item.usuario.Paterno +' '+item.usuario.Materno}}</v-col>
                            <!-- <v-col class=" m-0 p-1 " tag="strong" cols="12"> Creador email: </v-col> -->
                            <v-col cols="12" class="m-0 p-1 ">{{item.usuario.User}} </v-col>
                            <!-- <v-col class=" m-0 p-1 " tag="strong" cols="12"> Creador dependencia: </v-col> -->
                            <v-col cols="12" class="m-0 p-1 pb-3">{{getDependencias(item.usuario.ID_Dependencia)}} </v-col>
                          </v-row>
                          <v-row class="text-left m-0 pt-2 pb-2" v-if="item.aprobacion">
                            <v-col class=" m-0 p-1 " tag="strong" cols="12"> Datos de aprobación: </v-col>
                            <v-col cols="12" class="m-0 p-1 ">{{item.aprobacion.Nombre + ' '+ item.aprobacion.Paterno +' '+item.aprobacion.Materno}}</v-col>
                            <!-- <v-col class=" m-0 p-1 " tag="strong" cols="12"> Creador email: </v-col> -->
                            <v-col cols="12" class="m-0 p-1 ">{{item.aprobacion.User}} </v-col>
                            <!-- <v-col class=" m-0 p-1 " tag="strong" cols="12"> Creador dependencia: </v-col> -->
                            <v-col cols="12" class="m-0 p-1 pb-3">{{getDependencias(item.aprobacion.ID_Dependencia)}} </v-col>
                          </v-row>
                        </v-card>
                      </td>
                    </template>

                  </v-data-table>
                </v-app>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import excel from 'vue-excel-export';
  import Vue from "vue";
  import moment from 'moment'
  import {
    Select,
    Option,
    DatePicker
  } from "element-ui";

  import {
    mapFields
  } from "vee-validate";

  import Domicilio from "../Domicilio.vue";

  Vue.use(Select);
  Vue.use(Option);
  Vue.use(excel);

  export default {
    components: {
      [DatePicker.name]: DatePicker
    },
    props: ["data"],
    data() {
      return {
        expanded: [],
        filtro: null,
        filter: null,
        isLoading: false,
        currentPage: 1,
        perPage: 50,
        rol: "",
        rows: null,
        id: 1,
        dependencias: null,
        item_usuarios: {},
        lista_correcciones: [],
        lista_correcciones2: [],
        headers: [{
            text: '',
            value: 'data-table-expand'
          },
          // {
          //   text: 'Tipo movimiento',
          //   value: 'tipo_mov',
          //   align: 'center',
          // },
          {
            text: 'RFC',
            value: 'rfc',
            align: 'center',
          }, {
            text: 'Nombre',
            value: 'nombres',
            align: 'left',
          }, , {
            text: 'Fecha',
            value: 'created_at',
            align: 'center',
          },

        ],
        meta: [
          [{
            'key': 'charset',
            'value': 'utf-8'
          }]
        ],
        lista_campos: {
          'Nombres': 'nombres',
          'RFC': 'rfc',
          'CURP': 'curp',
          'Origen': 'origen',
          'Cambio': 'cambio',
          'Declaración Origen': 'origen_dec',
          'Declaración Cambio': 'cambio_dec',
          'Observaciones': 'observaciones',
          'Creador': 'creador',
          'Correo Creador': 'creador_mail',
          'Dependencia Creador': 'creador_dependencia',
          'Fecha': 'fecha',
          'Fecha': 'periodo',
          'Tipo declaración': 'tipo_declaracion',
        },

      };
    },
    computed: {
      to() {
        let highBound = this.from + this.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      total() {
        //console.log(this.lista_correcciones.length);
        this.rows = this.lista_correcciones.length;

        return this.lista_correcciones.length;
      },
      fullName: {
        get() {
          return `${this.item_usuarios.nombres} ${
          this.item_usuarios.primer_apellido
        } ${this.item_usuarios.segundo_apellido}`;
        },
        set(newValue) {
          const m = newValue.match(/(\S*)\s+(.*)/);

          this.nombres = m[1];
          this.primer_apellido = m[2];
          this.segundo_apellido = m[3];
        }
      }
    },
    methods: {
      tipoDecCat(tipo) {
        var t = '';
        switch (tipo) {
          case 1:
            t = 'Inicial';
            break;
          case 2:
            t = 'Anual';
            break;
          case 3:
            t = 'Final';
            break;

        }
        return t;
      },
      customFilter(value, search, item) {
        search = search.toString().toLowerCase();
        var filter = this.flat(item, {});

        return Object.values(filter).some(v => {
          // console.log(v);
          return v && v.toString().toLowerCase().includes(search)
        })
      },
      flat(obj, out) {
        if (obj) {
          Object.keys(obj).forEach(key => {
            if (typeof obj[key] == 'object') {
              out = this.flat(obj[key], out) //recursively call for nesteds
            } else {
              out[key] = obj[key] //direct assign for values
            }

          })
        }
        return out
      },
      rowClick(item, row) {
        const indexRow = item.index;
        const indexExpanded = this.expanded.findIndex(i => i === item);
        // console.log(indexExpanded);
        if (indexExpanded > -1) {
          this.expanded = [];
          row.select(false);
          // console.log('splice', this.expanded);
        } else {
          this.expanded = [item];
          row.select(true);
          // console.log('push', this.expanded);
        }
      },
      initItem() {
        this.item_usuarios = {
          acciones: "",
          nombres: "",
          Paterno: "",
          Materno: "",
          User: "",
          Password: ""
        };
      },

      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      getDependencias(index) {
        var resp = " ";
        if (this.dependencias) {
          this.dependencias.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },

      getcorrecciones() {
        this.lista_correcciones2 = [];

        this.isLoading = true;
        this.$http.get("bitacoracorreccion").then(
          response => {
            this.lista_correcciones = response.data.bitacora;

            this.lista_correcciones.forEach((value, key) => {

              this.isLoading = false;

              let usuario = {
                Nombre: '',
                Paterno: '',
                Materno: '',
                User: '',
                ID_Dependencia: '',
              };

              if (value.usuario) {
                usuario = value.usuario;
              }

              value.origen = JSON.parse(value.origen);
              value.cambio = JSON.parse(value.cambio);

              //
              var origen = this.flatData(value.origen.datos_encargo_actual, 'ente');
              var cambio = this.flatData(value.cambio.datos_encargo_actual, 'ente');


              var dec_origen = {
                tipo_declaracion: value.orgen_declaracion.Tipo_Dec,
                periodo: value.orgen_declaracion.periodo,
              };

              var dec_cambio = {
                tipo_declaracion: value.cambio_declaracion.Tipo_Dec,
                periodo: value.cambio_declaracion.periodo,
              };

              this.lista_correcciones2.push({
                'nombres': value.servidor.nombres + ' ' + value.servidor.primer_apellido + ' ' + value.servidor.segundo_apellido,
                'rfc': value.servidor.rfc,
                'curp': value.servidor.curp,
                'origen': origen ? Object.values(origen).join(', ') : '',
                'cambio': cambio ? Object.values(cambio).join(', ') : '',
                'origen_dec': dec_origen ? Object.values(dec_origen).join(', ') : '',
                'cambio_dec': dec_cambio ? Object.values(dec_cambio).join(', ') : '',
                'observaciones': value.observaciones ? value.observaciones : 'Sin observaciones.',
                'creador': usuario.Nombre + ' ' + usuario.Paterno + ' ' + usuario.Materno,
                'creador_mail': usuario.User,
                'creador_dependencia': this.getDependencias(usuario.ID_Dependencia),
                'fecha': this.dateFormat(value.created_at),
                'periodo': value.periodo,
                'tipo_declaracion': this.tipoDecCat(value.tipo_declaracion_id),
              });


            });
          },
          error => {
            this.isLoading = false;
            this.Err(error);
          }
        );
      },
      dateFormat: function (date, time = false) {
        if (date) {
          if (time) {
            return moment(date).format('DD/MM/YYYY HH:mm:ss');
          } else {
            return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
          }
        }
      },
      returnValueKey(v, k) {
        var resp = "";
        if (k == "dependencia") {
          resp = this.getDependencias(v);
        } else if (k == "honorarios") {
          console.log(typeof v);
          resp = v == 1 ? "HONORARIOS" : "BASE";
        } else if (k == "fecha_posesion") {
          resp = this.formato(v)
        } else if (k == "titular") {
          resp = v == 0 ? "NO" : "SI";
        } else if (k == "simplificada") {
          resp = v == '0' ? "NO" : "SI";
        } else {
          resp = v;
        }
        return resp;
      },
      flatData(value, key) {
        var resp = [];
        var json_ = JSON.parse(value);
        if (json_[0]) {
          let obj = json_[0];
          if (obj.hasOwnProperty(key)) {
            var resp = obj[key];
            delete resp.created_by;
            delete resp.deleted_by;
            delete resp.updated_by;
            delete resp.created_at;
            delete resp.deleted_at;
            delete resp.updated_at;
            delete resp.id;
          }
        }
        return resp;
      }
    },
    created() {
      this.initItem();
      this.getcorrecciones();
      this.rol = this.getKey("role");

      this.$http.get("cat_ente_publico").then(
        response => {
          this.dependencias = response.data.entes_publicos;
        },
        error => {
          this.Err(error);
        }
      );
    }
  };

</script>
<style>
  .v-data-table>.v-data-table__wrapper tbody tr.v-data-table__expanded__content {
    box-shadow: inset 0px 0px 0px 0px rgba(50, 50, 50, 0.15), inset 0px 0px 0px 1px rgba(50, 50, 50, 0.1);
    /* border: thin solid rgba(0, 0, 0, 0.12); */
  }

  .theme--light.v-divider {

    border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
  }

  tr.v-data-table__selected {
    background: rgba(0, 0, 0, 0.05) !important;
  }

  .w-50 {
    width: calc(100vw - 500px) !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Movimientos/ListaCorrecciones.vue